module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ixtr6"))).then(() => module.bundle.root('6TueN'));